import { Button } from './ui/button';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog';
import { AlertTriangle } from 'lucide-react';
import { useEffect, useState } from 'react';

type CreditAlertDetail = {
  availableCredits?: number;
  low?: boolean;
  exceeded?: boolean;
};

type AICreditAlertDialogProps = {
  onOpenWindow?: (appId: string, title: string) => void;
};

export default function AICreditAlertDialog({ onOpenWindow }: AICreditAlertDialogProps) {
  const [detail, setDetail] = useState<CreditAlertDetail | null>(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleExceeded = (event: Event) => {
      const customEvent = event as CustomEvent<CreditAlertDetail>;
      setDetail(customEvent.detail || null);
      setOpen(true);
    };

    window.addEventListener('mapleos:credits-exceeded', handleExceeded as EventListener);
    return () => window.removeEventListener('mapleos:credits-exceeded', handleExceeded as EventListener);
  }, []);

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-red-600">
            <AlertTriangle className="h-5 w-5" />
            AI usage exceeded
          </AlertDialogTitle>
          <AlertDialogDescription>
            You have exceeded your MapleOS AI credits and need to top up to keep using frontier AI models.
            {typeof detail?.availableCredits === 'number' ? ` Current balance: ${detail.availableCredits.toLocaleString()} credits.` : ''}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Close</AlertDialogCancel>
          <AlertDialogAction
            onClick={() => {
              onOpenWindow?.('ai-credits', 'AI Credits');
              setOpen(false);
            }}
          >
            Open AI Credits
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
